(function () {
  'use strict';

  if (window.__nsCareerPageScriptLoaded) {
    if (typeof window.__nsCareerInit === 'function') {
      window.__nsCareerInit(document);
    }
    return;
  }

  window.__nsCareerPageScriptLoaded = true;

  var ROOT_SELECTOR = '[data-ns-career-page]';
  var MAX_FILE_BYTES = 10 * 1024 * 1024;
  var DEFAULT_ENDPOINT = 'https://script.google.com/macros/s/AKfycbzYMnOl3K69zSIenutX7x-cEP4IAYp6x_W12nTzqeM2PwbY8-qOt0RYY5w9b6OxeWEm/exec';
  var ALLOWED_FILE_MESSAGE = 'CV måste vara PDF, DOC, DOCX, JPG, JPEG, PNG eller HEIC.';
  var ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'heic'];
  var UPLOAD_STEPS = ['validate', 'upload', 'send', 'done'];
  var ALLOWED_MIME_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/jpeg',
    'image/png',
    'image/heic',
    'image/heif',
    'application/octet-stream',
    ''
  ];

  function safeText(value) {
    return value === null || value === undefined ? '' : String(value);
  }

  function getValue(root, selector) {
    var node = root.querySelector(selector);
    return node ? safeText(node.value).trim() : '';
  }

  function getFileExtension(filename) {
    var match = safeText(filename).toLowerCase().match(/\.([a-z0-9]+)$/);
    return match ? match[1] : '';
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(safeText(value));
  }

  function formatBytes(bytes) {
    if (bytes >= 1024 * 1024) {
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    return Math.max(1, Math.round(bytes / 1024)) + ' kB';
  }

  function nowMs() {
    return window.performance && typeof window.performance.now === 'function'
      ? window.performance.now()
      : Date.now();
  }

  function elapsedMs(startTime) {
    return Math.round((nowMs() - startTime) * 100) / 100;
  }

  function logCareerTiming(label, timings) {
    if (!window.console || typeof window.console.info !== 'function') {
      return;
    }

    window.console.info('[career_application_timing] ' + label, timings);
  }

  function readFileAsBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onload = function () {
        resolve(safeText(reader.result).split('base64,').pop());
      };

      reader.onerror = function () {
        reject(new Error('Kunde inte läsa CV-filen.'));
      };

      reader.readAsDataURL(file);
    });
  }

  function focusValidationTarget(root, selector) {
    var target = root && selector ? root.querySelector(selector) : null;

    if (!target) {
      return;
    }

    target.setAttribute('aria-invalid', 'true');
    scrollToCareerNode(target.closest('.ns-career__field') || target.closest('.ns-career__privacy') || target);

    window.setTimeout(function () {
      focusNode(target, true);
    }, 120);
  }

  function clearValidationState(root) {
    if (!root) {
      return;
    }

    Array.prototype.forEach.call(root.querySelectorAll('[aria-invalid="true"]'), function (node) {
      node.removeAttribute('aria-invalid');
    });
  }

  function validateFile(file, root) {
    var extension;
    var mimeType;

    if (!file) {
      focusValidationTarget(root, '[data-ns-career-cv]');
      throw new Error('Ladda upp ditt CV.');
    }

    extension = getFileExtension(file.name);
    mimeType = safeText(file.type).toLowerCase();

    if (ALLOWED_EXTENSIONS.indexOf(extension) === -1) {
      focusValidationTarget(root, '[data-ns-career-cv]');
      throw new Error(ALLOWED_FILE_MESSAGE);
    }

    if (ALLOWED_MIME_TYPES.indexOf(mimeType) === -1) {
      focusValidationTarget(root, '[data-ns-career-cv]');
      throw new Error(ALLOWED_FILE_MESSAGE);
    }

    if (file.size > MAX_FILE_BYTES) {
      focusValidationTarget(root, '[data-ns-career-cv]');
      throw new Error('CV-filen får vara max 10 MB. Din fil är ' + formatBytes(file.size) + '.');
    }
  }

  function setMessage(node, message) {
    if (!node) {
      return;
    }

    node.hidden = !message;
    node.textContent = message || '';

    if (message) {
      node.focus();
    }
  }

  function setSubmitting(button, labelNode, statusNode, isSubmitting) {
    var idleLabel = button ? safeText(button.getAttribute('data-ns-career-submit-idle')).trim() : '';
    var submittingLabel = button ? safeText(button.getAttribute('data-ns-career-submit-submitting')).trim() : '';

    if (button) {
      button.disabled = isSubmitting;
    }

    if (labelNode) {
      labelNode.textContent = isSubmitting ? (submittingLabel || 'Skickar…') : (idleLabel || 'Skicka ansökan');
    }

    if (statusNode) {
      statusNode.hidden = !isSubmitting;
    }
  }

  function focusNode(node, preventScroll) {
    if (!node) {
      return;
    }

    try {
      node.focus({ preventScroll: preventScroll });
    } catch (error) {
      node.focus();
    }
  }

  function dispatchChange(node) {
    var event;

    if (!node) {
      return;
    }

    if (typeof Event === 'function') {
      event = new Event('change', { bubbles: true });
    } else {
      event = document.createEvent('Event');
      event.initEvent('change', true, false);
    }

    node.dispatchEvent(event);
  }

  function getCareerUrl() {
    try {
      return new URL(window.location.href);
    } catch (error) {
      return null;
    }
  }

  function getJobParam() {
    var url = getCareerUrl();

    return url ? safeText(url.searchParams.get('job')).trim() : '';
  }

  function buildJobUrl(slug) {
    var url = getCareerUrl();

    if (!url) {
      return window.location.href;
    }

    if (slug) {
      url.searchParams.set('job', slug);
    } else {
      url.searchParams.delete('job');
    }

    url.hash = '';

    return url.toString();
  }

  function updateJobHistory(slug) {
    var nextUrl;
    var currentSlug;

    if (!window.history || typeof window.history.pushState !== 'function') {
      return;
    }

    currentSlug = getJobParam();

    if (safeText(slug) === currentSlug) {
      return;
    }

    nextUrl = buildJobUrl(slug);
    window.history.pushState({ nsCareerJob: slug || '' }, '', nextUrl);
  }

  function getHeaderOffset() {
    var selectors = [
      '.shopify-section-header-sticky',
      '.shopify-section-header',
      'sticky-header',
      'header[role="banner"]',
      'header'
    ];
    var offset = 18;

    selectors.some(function (selector) {
      var node = document.querySelector(selector);
      var style;
      var rect;

      if (!node) {
        return false;
      }

      style = window.getComputedStyle ? window.getComputedStyle(node) : null;
      rect = node.getBoundingClientRect();

      if (rect.height && (!style || style.position === 'fixed' || style.position === 'sticky')) {
        offset = Math.ceil(rect.height) + 18;
        return true;
      }

      return false;
    });

    return offset;
  }

  function scrollToCareerNode(node) {
    var rect;
    var top;

    if (!node || typeof node.getBoundingClientRect !== 'function') {
      return;
    }

    rect = node.getBoundingClientRect();
    top = rect.top + window.pageYOffset - getHeaderOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });
  }

  function copyTextToClipboard(text) {
    if (window.navigator && window.navigator.clipboard && typeof window.navigator.clipboard.writeText === 'function') {
      return window.navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');

      textarea.value = text;
      textarea.setAttribute('readonly', 'readonly');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function getSharePayload(accordion) {
    var canReadAttributes = accordion && typeof accordion.getAttribute === 'function';
    var slug = canReadAttributes ? safeText(accordion.getAttribute('data-ns-career-job-slug')).trim() : '';
    var explicitUrl = canReadAttributes ? safeText(accordion.getAttribute('data-ns-career-job-url')).trim() : '';
    var title = canReadAttributes ? safeText(accordion.getAttribute('data-ns-career-share-title')).trim() : '';
    var text = canReadAttributes ? safeText(accordion.getAttribute('data-ns-career-share-text')).trim() : '';

    return {
      title: title || document.title,
      text: text,
      url: explicitUrl || buildJobUrl(slug)
    };
  }

  function setUploadStep(root, activeStep) {
    var activeIndex = UPLOAD_STEPS.indexOf(activeStep);
    var steps = root.querySelectorAll('[data-ns-career-step]');

    Array.prototype.forEach.call(steps, function (step) {
      var stepName = step.getAttribute('data-ns-career-step');
      var stepIndex = UPLOAD_STEPS.indexOf(stepName);
      var isComplete = stepIndex !== -1 && activeIndex !== -1 && stepIndex <= activeIndex;

      step.classList.toggle('is-complete', isComplete);
      step.setAttribute('aria-current', stepName === activeStep ? 'step' : 'false');
    });
  }

  function resetUploadSteps(root) {
    var steps = root.querySelectorAll('[data-ns-career-step]');

    Array.prototype.forEach.call(steps, function (step) {
      step.classList.remove('is-complete');
      step.setAttribute('aria-current', 'false');
    });
  }

  function buildPayload(root, file, base64Data) {
    return {
      type: 'career_application',
      submitted_at: new Date().toISOString(),
      company: getValue(root, '[data-ns-career-company]'),
      first_name: getValue(root, '[data-ns-career-first-name]'),
      last_name: getValue(root, '[data-ns-career-last-name]'),
      email: getValue(root, '[data-ns-career-email]'),
      phone: getValue(root, '[data-ns-career-phone]'),
      linkedin: getValue(root, '[data-ns-career-linkedin]'),
      location: getValue(root, '[data-ns-career-location]'),
      role: getValue(root, '[data-ns-career-role]'),
      presentation: getValue(root, '[data-ns-career-presentation]'),
      cv_file: {
        filename: file.name,
        mime_type: file.type || '',
        size: file.size,
        data: base64Data
      }
    };
  }

  function validatePrivacyConsent(root) {
    var checkbox = root.querySelector('[data-ns-career-privacy-consent]');

    if (checkbox && !checkbox.checked) {
      focusValidationTarget(root, '[data-ns-career-privacy-consent]');
      throw new Error('Bocka i samtyckesrutan innan du skickar ansökan.');
    }
  }

  function validatePayload(payload, root) {
    if (!payload.first_name) {
      focusValidationTarget(root, '[data-ns-career-first-name]');
      throw new Error('Ange förnamn.');
    }

    if (!payload.last_name) {
      focusValidationTarget(root, '[data-ns-career-last-name]');
      throw new Error('Ange efternamn.');
    }

    if (!isValidEmail(payload.email)) {
      focusValidationTarget(root, '[data-ns-career-email]');
      throw new Error('Ange en giltig e-postadress.');
    }

    if (!payload.phone) {
      focusValidationTarget(root, '[data-ns-career-phone]');
      throw new Error('Ange telefon.');
    }

    if (!payload.location) {
      focusValidationTarget(root, '[data-ns-career-location]');
      throw new Error('Ange ort.');
    }

    if (!payload.role) {
      focusValidationTarget(root, '[data-ns-career-role]');
      throw new Error('Välj roll.');
    }

    if (!payload.presentation) {
      focusValidationTarget(root, '[data-ns-career-presentation]');
      throw new Error('Berätta kort om dig själv.');
    }
  }

  function parseJsonResponse(response, text) {
    try {
      return JSON.parse(text);
    } catch (error) {
      throw new Error(response && response.ok
        ? 'Endpoint svarade inte med giltig JSON.'
        : 'Ansökan kunde inte skickas. Försök igen.');
    }
  }

  function showConfirmation(root, form) {
    var intro = root.querySelector('[data-ns-career-form-intro]');
    var confirmation = root.querySelector('[data-ns-career-confirmation]');
    var title = root.querySelector('[data-ns-career-confirmation-title]');
    var countdownNode = root.querySelector('[data-ns-career-countdown]');
    var homeLink = root.querySelector('[data-ns-career-home-link]');
    var secondsLeft = 7;
    var redirectTimer;
    var countdownPrefix = countdownNode ? safeText(countdownNode.getAttribute('data-ns-career-countdown-prefix')).trim() : '';

    if (intro) {
      intro.hidden = true;
    }

    if (form) {
      form.hidden = true;
    }

    if (!confirmation) {
      window.location.assign('/');
      return;
    }

    confirmation.hidden = false;

    function updateCountdown() {
      if (!countdownNode) {
        return;
      }

      countdownNode.textContent = secondsLeft === 7
        ? (countdownPrefix || 'Du skickas vidare till startsidan om 7 sekunder...')
        : secondsLeft + '...';
    }

    updateCountdown();

    if (title) {
      focusNode(title, true);
    }

    confirmation.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    redirectTimer = window.setInterval(function () {
      secondsLeft -= 1;

      if (secondsLeft <= 0) {
        window.clearInterval(redirectTimer);
        window.location.assign('/');
        return;
      }

      updateCountdown();
    }, 1000);

    if (homeLink) {
      homeLink.addEventListener('click', function (event) {
        event.preventDefault();
        window.clearInterval(redirectTimer);
        window.location.assign('/');
      }, { once: true });
    }
  }

  function initCareerForm(scope) {
    var form = scope.querySelector('[data-ns-career-form]');
    var root = form ? (form.closest('[data-ns-career-root]') || scope) : scope;
    var fileInput = root.querySelector('[data-ns-career-cv]');
    var companyInput = root.querySelector('[data-ns-career-company]');
    var submitButton = root.querySelector('[data-ns-career-submit]');
    var submitLabel = root.querySelector('[data-ns-career-submit-label]');
    var uploadStatus = root.querySelector('[data-ns-career-upload-status]');
    var errorNode = root.querySelector('[data-ns-career-error]');
    var endpoint = root.getAttribute('data-endpoint') || DEFAULT_ENDPOINT;
    var isSubmitting = false;

    if (!form || !fileInput || !submitButton) {
      return;
    }

    if (form.__nsCareerFormInitialized) {
      return;
    }

    form.__nsCareerFormInitialized = true;
    form.setAttribute('novalidate', 'novalidate');

    function submitCareerApplication(event) {
      if (event) {
        event.preventDefault();
      }

      if (isSubmitting) {
        return;
      }

      resetUploadSteps(root);
      setSubmitting(submitButton, submitLabel, uploadStatus, false);

      (async function () {
        var file;
        var base64Data;
        var payload;
        var response;
        var responseText;
        var result;
        var timings = {};
        var stepStartedAt;

        setMessage(errorNode, '');
        clearValidationState(root);

        if (companyInput && safeText(companyInput.value).trim()) {
          return;
        }

        if (!endpoint) {
          throw new Error('Formulärets endpoint saknas.');
        }

        file = fileInput.files && fileInput.files[0];
        setUploadStep(root, 'validate');
        stepStartedAt = nowMs();

        payload = buildPayload(root, file || { name: '', type: '', size: 0 }, '');
        validatePayload(payload, root);
        validateFile(file, root);
        validatePrivacyConsent(root);
        timings.file_validation_ms = elapsedMs(stepStartedAt);

        isSubmitting = true;
        setSubmitting(submitButton, submitLabel, uploadStatus, true);

        setUploadStep(root, 'upload');
        stepStartedAt = nowMs();
        base64Data = await readFileAsBase64(file);
        timings.base64_conversion_ms = elapsedMs(stepStartedAt);

        payload.cv_file.data = base64Data;
        payload.client_timings_ms = {
          file_validation_ms: timings.file_validation_ms,
          base64_conversion_ms: timings.base64_conversion_ms
        };

        setUploadStep(root, 'send');
        stepStartedAt = nowMs();
        response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'text/plain;charset=utf-8'
          },
          body: JSON.stringify(payload)
        });

        responseText = await response.text();
        timings.browser_to_apps_script_post_ms = elapsedMs(stepStartedAt);
        logCareerTiming('browser', timings);

        result = parseJsonResponse(response, responseText);

        if (result.timings_ms) {
          logCareerTiming('apps_script', result.timings_ms);
        }

        if (!response.ok || !result || result.status !== 'ok') {
          throw new Error(result && result.message ? result.message : 'Ansökan kunde inte skickas. Försök igen.');
        }

        setUploadStep(root, 'done');
        form.reset();
        showConfirmation(root, form);
      }()).catch(function (error) {
        setMessage(errorNode, error && error.message ? error.message : 'Ansökan kunde inte skickas. Försök igen.');
      }).finally(function () {
        isSubmitting = false;
        setSubmitting(submitButton, submitLabel, uploadStatus, false);
      });
    }

    form.addEventListener('submit', submitCareerApplication);
    submitButton.addEventListener('click', submitCareerApplication);
  }

  function initCareerAccordions(root) {
    function getAccordionScope(accordion) {
      return accordion ? (accordion.closest('[data-ns-career-accordions]') || accordion.closest('[data-ns-career-page]') || document) : root;
    }

    function getAccordions(scope) {
      return Array.prototype.slice.call((scope || document).querySelectorAll('[data-ns-career-role-accordion]'));
    }

    function findAccordionBySlug(slug, scope) {
      var normalizedSlug = safeText(slug).trim();

      if (!normalizedSlug) {
        return null;
      }

      return getAccordions(scope || document).filter(function (accordion) {
        return safeText(accordion.getAttribute('data-ns-career-job-slug')).trim() === normalizedSlug;
      })[0] || null;
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function updateCardCta(accordion, isOpen) {
      Array.prototype.forEach.call(accordion.querySelectorAll('[data-ns-career-card-cta]'), function (cta) {
        var closedText = safeText(cta.getAttribute('data-ns-career-card-cta-closed')).trim();
        var openText = safeText(cta.getAttribute('data-ns-career-card-cta-open')).trim();

        cta.textContent = isOpen ? (openText || closedText) : closedText;
      });
    }

    function setPanelOpen(panel, isOpen) {
      var duration = 280;

      if (!panel) {
        return;
      }

      window.clearTimeout(panel.__nsCareerPanelTimer);

      if (prefersReducedMotion()) {
        panel.hidden = !isOpen;
        panel.style.maxHeight = '';
        panel.style.opacity = '';
        panel.style.overflow = '';

        if (isOpen) {
          panel.removeAttribute('aria-hidden');
        } else {
          panel.setAttribute('aria-hidden', 'true');
        }

        return;
      }

      panel.style.overflow = 'hidden';

      if (isOpen) {
        panel.hidden = false;
        panel.removeAttribute('aria-hidden');
        panel.style.maxHeight = '0px';
        panel.style.opacity = '0';
        panel.offsetHeight;
        panel.style.maxHeight = panel.scrollHeight + 'px';
        panel.style.opacity = '1';

        panel.__nsCareerPanelTimer = window.setTimeout(function () {
          panel.style.maxHeight = '';
          panel.style.overflow = '';
        }, duration);
        return;
      }

      panel.setAttribute('aria-hidden', 'true');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.style.opacity = '1';
      panel.offsetHeight;
      panel.style.maxHeight = '0px';
      panel.style.opacity = '0';

      panel.__nsCareerPanelTimer = window.setTimeout(function () {
        panel.hidden = true;
        panel.style.maxHeight = '';
        panel.style.opacity = '';
        panel.style.overflow = '';
      }, duration);
    }

    function setAccordionOpen(accordion, isOpen, shouldScroll) {
      var toggle = accordion.querySelector('[data-ns-career-accordion-toggle]');
      var panel = accordion.querySelector('[data-ns-career-accordion-panel]');

      accordion.classList.toggle('is-open', isOpen);
      updateCardCta(accordion, isOpen);

      if (toggle) {
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      setPanelOpen(panel, isOpen);

      if (isOpen && shouldScroll && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        window.setTimeout(function () {
          scrollToCareerNode(accordion);
        }, 80);
      }
    }

    function closeAll(scope) {
      getAccordions(scope).forEach(function (accordion) {
        setAccordionOpen(accordion, false, false);
      });
    }

    function openOnly(accordion, shouldScroll, shouldUpdateHistory) {
      var scope = getAccordionScope(accordion);
      var slug = accordion ? safeText(accordion.getAttribute('data-ns-career-job-slug')).trim() : '';

      getAccordions(scope).forEach(function (otherAccordion) {
        setAccordionOpen(otherAccordion, otherAccordion === accordion, false);
      });

      if (shouldScroll) {
        window.setTimeout(function () {
          scrollToCareerNode(accordion);
        }, 80);
      }

      if (shouldUpdateHistory) {
        updateJobHistory(slug);
      }
    }

    function syncFromUrl(shouldScroll) {
      var accordion = findAccordionBySlug(getJobParam(), document);

      if (accordion) {
        openOnly(accordion, shouldScroll, false);
      } else {
        closeAll(document);
      }
    }

    getAccordions(root).forEach(function (accordion) {
      var toggle = accordion.querySelector('[data-ns-career-accordion-toggle]');

      if (!toggle) {
        return;
      }

      setAccordionOpen(accordion, false, false);
    });

    if (!document.__nsCareerAccordionsInitialized) {
      document.__nsCareerAccordionsInitialized = true;

      document.addEventListener('click', function (event) {
        var toggle = event.target.closest ? event.target.closest('[data-ns-career-accordion-toggle]') : null;
        var accordion = toggle ? toggle.closest('[data-ns-career-role-accordion]') : null;
        var shouldOpen;

        if (!accordion) {
          return;
        }

        shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';

        event.preventDefault();

        if (shouldOpen) {
          openOnly(accordion, true, true);
        } else {
          setAccordionOpen(accordion, false, false);
          updateJobHistory('');
        }
      });

      window.addEventListener('popstate', function () {
        syncFromUrl(true);
      });
    }

    if (getJobParam() && !window.__nsCareerInitialJobParamHandled) {
      window.__nsCareerInitialJobParamHandled = true;

      window.setTimeout(function () {
        var linkedAccordion = findAccordionBySlug(getJobParam(), document);
        var canonicalJobUrl = linkedAccordion ? safeText(linkedAccordion.getAttribute('data-ns-career-job-url')).trim() : '';

        if (canonicalJobUrl) {
          window.location.replace(canonicalJobUrl);
          return;
        }

        syncFromUrl(true);
      }, 120);
    }
  }

  function initCareerShare(root) {
    function hideMenus(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ns-career-share-menu]'), function (menu) {
        menu.hidden = true;
      });
    }

    function updateMenuLinks(menu, payload) {
      var emailLink = menu.querySelector('[data-ns-career-email-share]');
      var facebookLink = menu.querySelector('[data-ns-career-facebook-share]');
      var feedback = menu.querySelector('[data-ns-career-share-feedback]');
      var emailBody = payload.text ? payload.text + '\n\n' + payload.url : payload.url;

      if (emailLink) {
        emailLink.href = 'mailto:?subject=' + encodeURIComponent(payload.title) + '&body=' + encodeURIComponent(emailBody);
      }

      if (facebookLink) {
        facebookLink.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(payload.url);
      }

      if (feedback) {
        feedback.hidden = true;
      }
    }

    if (!document.__nsCareerShareInitialized) {
      document.__nsCareerShareInitialized = true;

      document.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-ns-career-share]') : null;
        var copyButton = event.target.closest ? event.target.closest('[data-ns-career-copy-link]') : null;
        var careerRoot;

        if (button) {
          var accordion = button.closest('[data-ns-career-role-accordion]') || button.closest('[data-ns-career-root]') || root;
          var shareWrap = button.closest('.ns-career__share');
          var menu = shareWrap ? shareWrap.querySelector('[data-ns-career-share-menu]') : null;
          var payload = getSharePayload(accordion);
          careerRoot = button.closest('[data-ns-career-page]') || document;

          event.preventDefault();
          event.stopPropagation();

          if (window.navigator && typeof window.navigator.share === 'function') {
            window.navigator.share(payload).catch(function (error) {
              if (error && error.name === 'AbortError') {
                return;
              }

              if (menu) {
                hideMenus(careerRoot);
                updateMenuLinks(menu, payload);
                menu.hidden = false;
              }
            });
            return;
          }

          if (menu) {
            hideMenus(careerRoot);
            updateMenuLinks(menu, payload);
            menu.hidden = false;
          }

          return;
        }

        if (copyButton) {
          var copyAccordion = copyButton.closest('[data-ns-career-role-accordion]') || copyButton.closest('[data-ns-career-root]') || root;
          var copyMenu = copyButton.closest('[data-ns-career-share-menu]');
          var feedback = copyMenu ? copyMenu.querySelector('[data-ns-career-share-feedback]') : null;
          var copyPayload = getSharePayload(copyAccordion);

          event.preventDefault();
          event.stopPropagation();

          copyTextToClipboard(copyPayload.url).then(function () {
            if (feedback) {
              feedback.hidden = false;
            }
          });
        }
      });

      document.addEventListener('click', function (event) {
        if (!event.target.closest || !event.target.closest('.ns-career__share')) {
          hideMenus(document);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          hideMenus(document);
        }
      });
    }
  }

  function initCareerRoleApplyButtons(root) {
    function getRoleSelect() {
      return document.querySelector('[data-ns-career-role]');
    }

    function getApplicationSection() {
      return document.querySelector('#ansokan') || document.querySelector('[data-ns-career-form]');
    }

    function syncRoleOptionsFromApplyButtons(roleSelect) {
      var currentValue = roleSelect.value;
      var placeholderOption = roleSelect.querySelector('option[value=""]');
      var roles = [];

      Array.prototype.forEach.call(document.querySelectorAll('[data-ns-career-apply-role]'), function (button) {
        var role = safeText(button.getAttribute('data-ns-career-apply-role')).trim();
        var alreadyAdded;

        if (!role || button.disabled) {
          return;
        }

        alreadyAdded = roles.some(function (existingRole) {
          return existingRole === role;
        });

        if (!alreadyAdded) {
          roles.push(role);
        }
      });

      while (roleSelect.options.length > 0) {
        roleSelect.remove(0);
      }

      if (placeholderOption) {
        roleSelect.appendChild(placeholderOption);
        placeholderOption.selected = true;
      }

      roles.forEach(function (role) {
        var option = document.createElement('option');

        option.value = role;
        option.textContent = role;
        roleSelect.appendChild(option);
      });

      if (currentValue && roles.indexOf(currentValue) !== -1) {
        roleSelect.value = currentValue;
      }
    }

    function selectRoleAndScroll(role) {
      var roleSelect = getRoleSelect();
      var applicationSection = getApplicationSection();
      var optionExists;

      if (!roleSelect || !applicationSection) {
        return;
      }

      if (!role) {
        return;
      }

      optionExists = Array.prototype.some.call(roleSelect.options, function (existingOption) {
        return existingOption.value === role;
      });

      if (!optionExists) {
        syncRoleOptionsFromApplyButtons(roleSelect);
        optionExists = Array.prototype.some.call(roleSelect.options, function (existingOption) {
          return existingOption.value === role;
        });
      }

      if (!optionExists) {
        var option = document.createElement('option');

        option.value = role;
        option.textContent = role;
        roleSelect.appendChild(option);
      }

      roleSelect.value = role;
      dispatchChange(roleSelect);

      scrollToCareerNode(applicationSection);

      window.setTimeout(function () {
        focusNode(roleSelect, true);
      }, 450);
    }

    if (getRoleSelect()) {
      syncRoleOptionsFromApplyButtons(getRoleSelect());
    }

    if (!document.__nsCareerApplyInitialized) {
      document.__nsCareerApplyInitialized = true;

      document.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-ns-career-apply-role]') : null;
        var role;

        if (!button) {
          return;
        }

        role = button.getAttribute('data-ns-career-apply-role') || '';

        event.preventDefault();
        event.stopPropagation();
        selectRoleAndScroll(role);
      });
    }

    if (!window.__nsCareerApplyParamHandled) {
      window.__nsCareerApplyParamHandled = true;

      window.setTimeout(function () {
        var url = getCareerUrl();
        var role = url ? safeText(url.searchParams.get('apply')).trim() : '';

        if (role) {
          selectRoleAndScroll(role);
        }
      }, 180);
    }
  }

  function initCareerPrivacyConsent(root) {
    try {
      Array.prototype.forEach.call((root || document).querySelectorAll('.ns-career__privacy-link'), function (link) {
        if (typeof link.remove === 'function') {
          link.remove();
        } else if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });

      Array.prototype.forEach.call((root || document).querySelectorAll('.ns-career__privacy-check a'), function (link) {
        var textNode = document.createTextNode(safeText(link.textContent));

        if (typeof link.replaceWith === 'function') {
          link.replaceWith(textNode);
        } else if (link.parentNode) {
          link.parentNode.replaceChild(textNode, link);
        }
      });
    } catch (error) {
      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn('[career_privacy_cleanup_failed]', error);
      }
    }
  }

  function initCareerHashLinks() {
    if (document.__nsCareerHashLinksInitialized) {
      return;
    }

    document.__nsCareerHashLinksInitialized = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('.ns-career a[href*="#"]') : null;
      var url;
      var target;

      if (!link) {
        return;
      }

      try {
        url = new URL(link.getAttribute('href'), window.location.href);
      } catch (error) {
        return;
      }

      if (!url.hash || url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
        return;
      }

      target = document.querySelector(url.hash);

      if (!target) {
        return;
      }

      event.preventDefault();
      scrollToCareerNode(target);
    });
  }

  function initBenefitCarousels(root) {
    var carousels = root.querySelectorAll('[data-ns-career-benefit-carousel]');

    function scrollTrack(track, direction) {
      var amount;

      if (!track) {
        return;
      }

      amount = Math.max(280, Math.round(track.clientWidth * 0.82));
      track.scrollBy({
        left: direction * amount,
        behavior: 'smooth'
      });
    }

    Array.prototype.forEach.call(carousels, function (carousel) {
      var track = carousel.querySelector('[data-ns-career-benefit-track]');
      var previousButton = carousel.querySelector('[data-ns-career-benefit-prev]');
      var nextButton = carousel.querySelector('[data-ns-career-benefit-next]');

      if (!track || carousel.__nsCareerBenefitCarouselInitialized) {
        return;
      }

      carousel.__nsCareerBenefitCarouselInitialized = true;

      if (previousButton) {
        previousButton.addEventListener('click', function () {
          scrollTrack(track, -1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          scrollTrack(track, 1);
        });
      }

      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollTrack(track, -1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollTrack(track, 1);
        }
      });
    });
  }

  function initCareerPage(root) {
    initCareerHashLinks(root);
    initBenefitCarousels(root);
    initCareerAccordions(root);
    initCareerShare(root);
    initCareerRoleApplyButtons(root);
    initCareerForm(root);
    initCareerPrivacyConsent(root);
  }

  function bootCareerPage() {
    if (document.querySelector(ROOT_SELECTOR) || document.querySelector('.ns-career')) {
      initCareerPage(document);
    }
  }

  window.__nsCareerInit = function (scope) {
    initCareerPage(scope || document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCareerPage);
  } else {
    bootCareerPage();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCareerPage(event.target || document);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initCareerPage(event.target || document);
  });
}());
